import { AxiosError } from "axios";
import { toastEmitter } from "helpers/helpers";
import { useState } from "react";

export function useError(
  t: (key: string) => string,
  defaultErrorMessage: string = "fetchError",
) {
  const [errorMessage, setErrorMessage] = useState<string>();
  const onError = (error: unknown) => {
    const err = error as AxiosError<{ error?: string }>;
    toastEmitter(t(err.response?.data?.error ?? defaultErrorMessage), "error");
    setErrorMessage(t(err.response?.data?.error ?? defaultErrorMessage));
  };

  return { errorMessage, onError };
}
